import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';

export default class InlineText extends React.Component {

	id;

	static escapeScript(value) {
		return value
			.replace(/<script/g, '<!--<script')
			.replace(/<\/script>/g, '</script>-->');
	}

	constructor(props) {
		super(props);

		this.id = uuidv4();
		this.state = {
			value: props.value,
			name: props.name,
			showInputBox: false
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.showFocus = this.showFocus.bind(this);
		this.hideFocus = this.hideFocus.bind(this);
	}

	handleInputChange(event) {
		const valueObject = this.state.value;
		valueObject.set(InlineText.escapeScript(event.target.value));
		valueObject.changed(valueObject.get());
		this.setState({
			value: valueObject
		});

		const returnEvent = {
			target: {
				name: this.state.name,
				value: valueObject
			}
		};
		this.props.change(returnEvent);
	}

	showFocus() {
		this.setState({
			showInputBox: true
		});
	}

	hideFocus(event) {
		this.handleInputChange(event);
		this.setState({
			showInputBox: false
		});
	}

	render() {
		return (
			<React.Fragment>
				<label id="mylabelid" htmlFor={this.id}>
					<strong className="inline">
						{this.props.label}
						<a
							data-toggle="tooltip"
							className="help"
							title={gettext(
								'Identifier - (e.g., \'question1\') Identifiers are used to refer to ' +
								'questions when programming advanced logic conditions.')}
						>
							(?)
						</a>
					</strong>
					{
						this.state.showInputBox
							? (
								<input
									type="text"
									name="identifier"
									id={this.id}
									onBlur={this.hideFocus}
									value={this.state.value.get() ? this.state.value.get() : ''}
									onChange={this.handleInputChange}
								/>
							) : (
								<a
									className="label label-primary identifier"
									onClick={this.showFocus}>
									{this.state.value.get() ? this.state.value.get() : gettext('None')}
								</a>
							)
					}
				</label>
			</React.Fragment>
		);
	}
}
